import React from 'react';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

import * as ErrorService from '../ErrorService';
import { DefaultErrorMessage } from './ErrorBoundary.styles';
import { errorBoundaryDefaultText } from '../constants';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error) {
    const errorArgs = omitBy(
      {
        error,
        showPopup: this.props.showPopup,
        customMessage: this.props.customMessage,
        customFields: this.props.customFields,
        popupOnly: this.props.popupOnly,
        logout: this.props.logout,
      },
      isNil
    );

    ErrorService.handleError(errorArgs);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <DefaultErrorMessage>{errorBoundaryDefaultText}</DefaultErrorMessage>;
    }

    return this.props.children;
  }
}
